import Vue from 'vue';
import elementLocale from 'element-ui/lib/locale';
import elementZh from 'element-ui/lib/locale/lang/zh-CN';
import elementEn from 'element-ui/lib/locale/lang/en';
import elementJa from 'element-ui/lib/locale/lang/ja';
import vantLocale from 'vant/lib/locale';
import vantZh from 'vant/lib/locale/lang/zh-CN';
import vantEn from 'vant/lib/locale/lang/en-US';
import vantJa from 'vant/lib/locale/lang/ja-JP';
import zh from './zh-CN.json';
import en from './en.json';
import ja from './ja.json';

export const LOCALE_STORAGE_KEY = 'ilean-locale';
export const supportedLocales = [
  { value: 'zh-CN', label: '中文' },
  { value: 'en', label: 'English' },
  { value: 'ja', label: '日本語' },
];
const messages = { 'zh-CN': zh, en, ja };
const elementMessages = { 'zh-CN': elementZh, en: elementEn, ja: elementJa };
const vantMessages = { 'zh-CN': vantZh, en: vantEn, ja: vantJa };

export function normalizeLocale(value) {
  const language = String(value || '').toLowerCase().split(/[-_]/)[0];
  if (language === 'zh') return 'zh-CN';
  return language === 'en' || language === 'ja' ? language : null;
}

export function detectLocale() {
  try {
    const saved = normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
    if (saved) return saved;
  } catch (error) { /* Storage may be unavailable in private browsing. */ }
  const languages = typeof navigator === 'undefined' ? [] : navigator.languages || [navigator.language];
  return languages.map(normalizeLocale).find(Boolean) || 'zh-CN';
}

export const localeState = Vue.observable({ locale: detectLocale() });

// Chinese source text is the stable key. Unknown keys are preserved, never guessed.
export function t(key, params = {}) {
  const catalog = messages[localeState.locale] || zh;
  const message = Object.prototype.hasOwnProperty.call(catalog, key) ? catalog[key] : key;
  return String(message == null ? '' : message).replace(/\{(\w+)\}/g, (token, name) =>
    Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : token);
}

export function setLocale(value, persist = true) {
  const locale = normalizeLocale(value) || 'zh-CN';
  localeState.locale = locale;
  vantLocale.use(locale === 'en' ? 'en-US' : locale === 'ja' ? 'ja-JP' : locale, vantMessages[locale]);
  if (typeof document !== 'undefined') {
    document.documentElement.lang = locale;
    document.title = t('爱精益 | 丰田模式现场5S问题清单管理');
  }
  if (persist) {
    try { localStorage.setItem(LOCALE_STORAGE_KEY, locale); } catch (error) { /* Keep the in-memory choice. */ }
  }
  return locale;
}

export function initializeI18n() {
  Vue.prototype.$t = t;
  Vue.prototype.$localeState = localeState;
  // Reading reactive locale here also refreshes Element UI's own computed labels.
  elementLocale.i18n((key, params = {}) => {
    const message = key.split('.').reduce((value, part) => value && value[part], elementMessages[localeState.locale]);
    return typeof message === 'string'
      ? message.replace(/\{(\w+)\}/g, (token, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : token)
      : message;
  });
  setLocale(localeState.locale, false);
  if (typeof window !== 'undefined') {
    window.addEventListener('storage', event => {
      if (event.key === LOCALE_STORAGE_KEY || event.key === null) setLocale(detectLocale(), false);
    });
  }
}
